import { render, staticRenderFns } from "./CommentsTabHeader.vue?vue&type=template&id=3f2cf2d2"
import script from "./CommentsTabHeader.vue?vue&type=script&lang=js"
export * from "./CommentsTabHeader.vue?vue&type=script&lang=js"
import style0 from "./CommentsTabHeader.vue?vue&type=style&index=0&id=3f2cf2d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports